import React from 'react';
import CustomLink from '../CustomLink';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { useViewedTracking } from '../../shared/use-viewed-tracking';
import { useRouting } from '../../shared/use-routing';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import { pagePathnames } from '../../pages/page-routes';
import styles from './NoSubCard.css';

function NoSubCard() {
    const { buildPath } = useRouting();

    useViewedTracking(true);

    return (
        <section
            className={styles.root}
            data-viewed-event={EVENT_TYPES.DASHBOARD_STATUS_CARD_VIEWED}
            data-viewed-props='{"cardType":"no_subscription"}'
        >
            <CustomLink
                to={buildPath(pagePathnames.account)}
                className={styles.planStatusBadge}
                onClick={() => logEvent(EVENT_TYPES.VIEW_PLAN_CLICKED, {})}
            >
                <span className={styles.planStatusDot} />
                You have no active plan
            </CustomLink>
            <div className={styles.statusRow}>
                <div className={styles.statusIconWrap}>
                    <Icon name='shieldWarning' className={styles.statusIcon} />
                </div>
                <h1 className={styles.statusTitle}>Start preserving your memories</h1>
            </div>
            <p className={styles.statusText}>
                Subscribe to start recording your life story — in your own words — and watch it grow into beautiful chapters for your family to keep forever.
            </p>
            <div className={styles.statusButtonWrapper}>
                <Button
                    label='Get started'
                    type='special-1'
                    onClick={() => logEvent(EVENT_TYPES.PREMIUM_BUTTON_CLICKED)}
                    link={{ to: buildPath(pagePathnames.premium) }}
                />
            </div>
        </section>
    );
}

export {
    NoSubCard
};
